import type { SVGProps } from "react";
export function Image(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <g clipRule="evenodd" fill="currentColor" fillRule="evenodd">
        <path d="m.833374 2.33337c0-.82842.671576-1.499996 1.499996-1.499996h11.33333c.8284 0 1.5.671576 1.5 1.499996v11.33333c0 .8284-.6716 1.5-1.5 1.5h-11.33333c-.82842 0-1.499996-.6716-1.499996-1.5zm1.499996-.5c-.27614 0-.5.22386-.5.5v11.33333c0 .2761.22386.5.5.5h11.33333c.2761 0 .5-.2239.5-.5v-11.33333c0-.27614-.2239-.5-.5-.5z" />
        <path d="m8.38893 5.33337c0-1.25798 1.01979-2.27777 2.27777-2.27777 1.258 0 2.2778 1.01979 2.2778 2.27777 0 1.25799-1.0198 2.27778-2.2778 2.27778-1.25798 0-2.27777-1.01979-2.27777-2.27778zm2.27777-1.27777c-.70569 0-1.27777.57208-1.27777 1.27777 0 .7057.57208 1.27778 1.27777 1.27778.7057 0 1.2778-.57208 1.2778-1.27778 0-.70569-.5721-1.27777-1.2778-1.27777z" />
        <path d="m7.0969 9.86723c-1.19372-.42353-2.51268-.30646-3.61314.32067-.23992.1368-.54525.0531-.68198-.1868-.13673-.23991-.05308-.54525.18684-.68198 1.35311-.77115 2.97487-.9151 4.44266-.39433 1.46778.52076 2.63622 1.65461 3.20072 3.10621.1001.2573-.0274.5471-.2848.6472s-.54714-.0274-.64723-.2848c-.45911-1.1805-1.40935-2.1026-2.60307-2.52617z" />
        <path d="m12.5581 11.2239c-.8198-.6855-2.0199-.6598-2.80968.06-.20408.1861-.52032.1714-.70635-.0327-.18602-.204-.17138-.5203.0327-.7063 1.15943-1.05683 2.92133-1.09448 4.12483-.0881.2118.1771.24.4924.0628.7043-.1771.2118-.4924.2399-.7043.0628z" />
      </g>
    </svg>
  );
}
